<template>
    <div class="container" :class="language">
        <div class="top-box">
            <img src="../../../static/images/index/bg_attend.png" class="bgImg" alt="" />
            <div>{{ content.heading }}</div>
            <button @click.stop="languageChange"><span class="iconfont icon-mutual"></span>{{ language === 'zh' ? 'Switch to English':'切换中文'}}</button>
        </div>
        <div class="info-box">
            <div class="ib_title">{{ content.subtit1 }}</div>
            <div class="line_item">
                <div><span class="redStar">{{ content.name }}</span></div>
                <div>
                    <input type="text" :placeholder="content.name_placeholder"
                        placeholder-class="pClass" v-model="info.Name" style="width: 60%;" />
                    <div class="inradio">
                        <div class="roitem" style="margin-right:20px;" @click.stop="info.Sex = 0">
                            <span class="iconfont"
                                :class="info.Sex == 0 ? 'icon-radio-on' : 'icon-radio'"></span>{{ content.sex0 }}
                        </div>
                        <div class="roitem" @click.stop="info.Sex = 1">
                            <span class="iconfont"
                                :class="info.Sex == 1 ? 'icon-radio-on' : 'icon-radio'"></span>{{ content.sex1 }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="line_item">
                <div><span class="redStar">{{ content.phone }}</span></div>
                <div class="phone-input-wrapper">
                    <select class="area-code-select" v-model="info.AreaCode" v-if="language === 'zh'">
                        <option v-for="item in areaCodeList" :key="item.code" :value="item.code">{{ item.code }}&emsp;{{ item.label }}&emsp;</option>
                    </select>
                    <input :type="language==='zh'?'number':'text'" :placeholder="content.phone_placeholder" placeholder-class="pClass"
                        v-model="info.Mobile"></input>
                </div>
            </div>
            <!-- 手机 -->
            <div class="line_item" v-if="language === 'zh'">
                <div><span class="redStar">{{ content.code }}</span></div>
                <div class="li_code">
                    <input type="number" :placeholder="content.code_placeholder" placeholder-class="pClass"
                        v-model="info.Code" @blur="onPhoneCodeBlur"></input>
                    <button :disabled="disabled" @click.stop="getPhoneCode">{{ content.code_get }}</button>
                </div>
            </div>
            <div class="line_item">
                <div><span class="redStar">{{ content.email }}</span></div>
                <div><input type="text" :placeholder="content.email_placeholder" placeholder-class="pClass"
                        v-model="info.Email"></input>
                </div>
            </div>
            <!-- 邮箱 -->
            <div class="line_item" v-if="language === 'en'">
                <div><span class="redStar">{{ content.code }}</span></div>
                <div class="li_code">
                    <input type="text" :placeholder="content.code_placeholder" placeholder-class="pClass"
                        v-model="info.Code"></input>
                    <button :disabled="disabled" @click.stop="getEmailCode">{{ content.code_get }}</button>
                </div>
            </div>
            <div class="line_item ah">
                <div><span class="redStar">{{ content.idtype }}</span></div>
                <div class="lbradio">
                    <div class="roitem" v-for="(item, key, index) in idtypeArray" :key="key"
                        @click.stop="info.IdType = key">
                        <span class="iconfont" :class="info.IdType == key ? 'icon-radio-on' : 'icon-radio'"></span>
                        <span>{{ item }}</span>
                    </div>
                </div>
            </div>
            <div class="line_item">
                <div><span class="redStar">{{ content.idcode }}</span></div>
                <div><input :type="info.IdType == 1 ? 'idcard' : 'text'" :placeholder="content.idcode_placeholder"
                        placeholder-class="pClass" v-model="info.IdCode"></input></div>
            </div>
        </div>
        <div class="info-box">
            <div class="ib_title" style="margin-bottom:0px;">{{ content.subtit2 }}</div>
            <div class="ib_tips">{{ content.tip }}</div>
            <div class="line_item" style="position: relative;">
                <div><span class="redStar">{{ content.company }}</span></div>
                <div><input type="text" :placeholder="content.company_placeholder" placeholder-class="pClass"
                        v-model="info.CompanyName" @input="companyNameInput"></input></div>
                <div class="result" v-if="companylist.length > 0">
                    <div class="iconfont icon-clear" @click.stop="companylist = [];"></div>
                    <div v-for="(item, index) in companylist" :key="index" class="citem"
                        @click.stop="info.CompanyName = item.name; companylist = [];">{{ item.name }}</div>
                </div>
            </div>
            <div class="line_item">
                <div><span class="redStar">{{ content.duty }}</span></div>
                <div><input type="text" :placeholder="content.duty_placeholder" placeholder-class="pClass"
                        v-model="info.Duty"></input></div>
            </div>
            <div class="line_item ah">
                <div><span class="redStar">{{ content.job }}</span></div>
                <div class="li_dropdown" @click.stop="jobShow = true">
                    <div>
                        <span v-if="info.JobFunction">{{ info.JobFunction }}</span>
                        <span class="pClass" v-else>{{ content.job_placeholder }}</span>
                    </div>
                    <span class="iconfont icon-arrow-down"></span>
                </div>
            </div>
            <!-- 职位性质picker -->
            <van-popup v-model="jobShow" round position="bottom"> 
                <van-picker show-toolbar title="" :cancel-button-text="content.btn_cancel" :confirm-button-text="content.btn_confirm" 
                :columns="jobArray" @cancel="jobShow = false" @confirm="info.JobFunction = $event; jobShow = false;" />
            </van-popup>
            <div class="line_item ah">
                <div><span class="redStar">{{ content.country }}</span></div>
                <div class="li_dropdown"
                    @click.stop="country.name = info.Country; country.id = info.CountryId; gjShow = true">
                    <div>
                        <span v-if="info.Country">{{ info.Country }}</span>
                        <span class="pClass" v-else>{{ content.country_placeholder }}</span>
                    </div>
                    <span class="iconfont icon-arrow-down"></span>
                </div>
            </div>
            <!-- 国家弹窗 -->
            <van-popup v-model="gjShow" round position="bottom">
                <div class="pop-box">
                    <button class="pbcancel" @click.stop="gjShow = false">{{ content.btn_cancel }}</button>
                    <button class="pbconfirm" @click.stop="gjConfirm">{{ content.btn_confirm }}</button>
                    <div class="pbtit">{{ content.country_placeholder }}</div>
                    <div class="country-search">
                        <span class="iconfont icon-search" style="font-size:14px;color:#999;"></span>
                        <input type="text" :placeholder="content.country_search_placeholder" placeholder-class="pClass" confirm-type="search"
                            v-model="gjKeyword" @input="getCountryValue" @keyup.enter="onCountryConfirm" />
                        <div @click.stop="onCountryClear" v-if="gjKeyword">
                            <span class="iconfont icon-clear"></span>
                        </div>
                    </div>
                    <div class="pbscroll">
                        <div v-for="(item, index) in gjArray" :key="index" class="country-item"
                            @click.stop="onCountryItemSelect(item)">
                            <span class="iconfont" :class="country.id == item.id ? 'icon-radio-on' : 'icon-radio'"></span>
                            <div>{{ language === 'zh' ? item.name : item.name_en }}</div>
                        </div>
                        <div class="noDataBox" v-if="gjArray.length == 0">
                            <div class="kongIcon"><span class="iconfont icon-kong"></span></div>
                            <div>{{ content.country_search_no }}</div>
                        </div>
                    </div>
                </div>
            </van-popup>
            <div class="line_item" style="border-bottom: 0;" @click.stop="openArea">
                <div><span class="redStar">{{ content.address }}</span></div>
                <div class="li_dropdown ads">
                    <div>
                        <span v-if="info.ProvinceName">{{ info.ProvinceName + ' ' + info.CityName + ' ' + info.RegionName }}</span>
                        <span class="pClass" v-else>{{ content.address_placeholder1 }}</span>
                    </div>
                    <span class="iconfont icon-arrow-down"></span>
                </div>
            </div>
            <!-- 省市区弹窗 -->
            <van-popup v-model="areaShow" round position="bottom">
                <van-picker :title="content.address_placeholder1" :cancel-button-text="content.btn_cancel" :confirm-button-text="content.btn_confirm" 
                show-toolbar ref="areaPicker" :columns="areaArray" :value-key="language==='zh'?'name':'name_en'" @confirm="onAreaConfirm" @cancel="areaShow = false" @change="onAreaChange" />
            </van-popup>
            <div class="line_item">
                <div></div>
                <div><input type="text" :placeholder="content.address_placeholder2" placeholder-class="pClass" v-model="info.Address"></input></div>
            </div>
        </div>
        <div class="btn-box">
            <div @click.stop="nextClick">{{ content.btn }}</div>
        </div>
    </div>
</template>
<script>
import { Popup, Picker, Icon } from "vant";
import { beforeInfo, addRecords, addViews, getQueryEnterpriseName, getApiInfo, getApiArea, sendEmailCode } from "@/api/exhibition";
import { sendSMS, sendSMSToGlobal } from "@/api/login";
import validator from "@/utils/validator";
export default {
    name: "attendinfocopy",
    components: {
        "van-popup": Popup,
        "van-picker": Picker,
        "van-icon": Icon
    },
    data() {
        return {
            language: 'zh',
            // 语言内容定义
            messages: {
                zh: {
                    heading: '观众预登记',
                    subtit1: '个人信息',
                    subtit2: '公司信息',
                    tip: '请如实填写以下信息，部分内容将打印在观展吊牌上。',
                    name: '姓名',
                    sex0: '先生',
                    sex1: '女士',
                    name_placeholder: '请输入您的真实姓名',
                    phone: '电话',
                    phone_placeholder: '请输入您的手机号码',
                    phone_err: "输入手机号有误！",
                    email: '邮箱',
                    email_placeholder: '请输入邮箱号',
                    email_err: "输入邮箱格式有误",
                    code: '验证码',
                    code_placeholder: '请输入手机验证码',
                    code_get: '获取验证码',
                    idtype: '证件类型',
                    idcode: '证件号码',
                    idcode_placeholder: '请输入正确的证件号码',
                    company: '名称',
                    company_placeholder: '请输入公司名称',
                    duty: '职位',
                    duty_placeholder: '请输入职位',
                    job: '职位性质',
                    job_placeholder: '请选择',
                    country: '国家',
                    country_placeholder: '请选择国家',
                    country_search_placeholder: '请输入关键词搜索',
                    country_search_no: '暂无匹配选项！请换个关键字试试',
                    country_search_no_err: '请换个关键字试试',
                    address: '地址',
                    address_placeholder1: '请选择省市区县',
                    address_placeholder2: '请输入详细地址',
                    btn_cancel: '取消',
                    btn_confirm: '确定',
                    btn: '提交',
                    success: '门票登记成功！'
                },
                en: {
                    heading: 'Audience Registration',
                    subtit1: 'Basic information:',
                    subtit2: 'Enterprise information:',
                    tip: 'Please confirm the accuracy of the information before submission.',
                    name: 'Name',
                    sex0: 'Mr.',
                    sex1: 'Ms.',
                    name_placeholder: 'Please enter your name',
                    phone: 'Phone',
                    phone_placeholder: 'Please enter your phone number',
                    phone_err: "Please enter a valid phone number.",
                    email: 'Email',
                    email_placeholder: 'Please enter the email number',
                    email_err: "Please enter a valid email address.",
                    code: 'Verification code',
                    code_placeholder: 'Email verification code',
                    code_get: 'Get code',
                    idtype: 'ID Type',
                    idcode: 'ID Number',
                    idcode_placeholder: 'Please enter identification number',
                    company: 'Company',
                    company_placeholder: 'Please enter the company',
                    duty: 'Position',
                    duty_placeholder: 'Please enter the position',
                    job: 'Nature',
                    job_placeholder: 'Please select the job function',
                    country: 'Country',
                    country_placeholder: 'Please select the country',
                    country_search_placeholder: 'Please enter search keywords',
                    country_search_no: 'No results found. Please try different keywords.',
                    country_search_no_err: 'Please try different keywords.',
                    address: 'Detailed',
                    address_placeholder1: 'Please select your region',
                    address_placeholder2: 'Please enter the detailed address',
                    btn_cancel: 'Cancel',
                    btn_confirm: 'Confirm',
                    btn: 'Submit',
                    success: 'Ticket registration successful!',
                }
            },
            content: "",
            allCountry: [], //所有国家

            timer: null,
            disabled: false,
            // 证件类型 certificates_type certificates_type_en
            certificates: [],
            idtypeArray: "",
            // 职业性质
            jobShow: false,
            jobArray: [],
            // 国家
            gjArray: [],
            gjKeyword: "",
            gjShow: false,
            country: {
                name: "",
                id: 0,
            },
            // 省市区
            areaShow: false,
            areaArray: [
                {
                    values: [], // 省份列表
                    defaultIndex: 0
                },
                {
                    values: [], // 城市列表
                    defaultIndex: 0
                },
                {
                    values: [], // 区县列表
                    defaultIndex: 0
                }
            ],
            // 区号列表
            areaCodeList: [
                { code: '+86', label: '中国' },
                { code: '+852', label: '香港' },
                { code: '+853', label: '澳门' },
                { code: '+886', label: '台湾' }
            ],
            // 填写数据
            info: {
                "Name": "",
                "Duty": "",
                "Mobile": "",
                "AreaCode": "+86",
                "IdCode": "",
                "IdType": 1,
                "Address": "",
                "CityName": "",
                "CompanyName": "",
                "ProvinceName": "",
                "RegionName": "",
                "Email": "",
                "ShareMemberId": 0,
                "ShareStoreId": 0,
                "Code": "",
                "ExhibitionQuestions": [], //展会问卷
                "CnId": 0, //渠道
                "Sex": 0, // 0男 1女
                "JobFunction": "", //职业性质
                "Country": "", //国家，默认中国
                "CountryId": 0
            },
            companylist: [], // 关联公司
            submitting: false //提交中
        };
    },
    computed: {

    },
    methods: {
        // 中英文切换-重新赋值（无感刷新）
        languageChange: function () {
            let name = '';
            if (this.language === 'zh') {
                this.language = 'en';
                this.content = this.messages['en'];
                name = '_en';
                this.gjArray = this.allCountry.filter(item => item.id !== 43167); // 除中国外
            } else {
                this.language = 'zh';
                this.content = this.messages['zh'];
                this.gjArray = [...this.allCountry];
            }
            this.idtypeArray = this.certificates[`certificates_type${name}`];
            this.country = {
                name: this.gjArray[0][`name${name}`],
                id: this.gjArray[0].id
            }
            this.info.AreaCode = "+86";
            this.info.Country = this.gjArray[0][`name${name}`];
            this.info.CountryId = this.gjArray[0].id;
            this.info.ProvinceName = "";
            this.info.CityName = "";
            this.info.RegionName = "";
            this.info.Address = "";
            this.areaArray = [
                {values: [],defaultIndex: 0},
                {values: [],defaultIndex: 0},
                {values: [],defaultIndex: 0}
            ];
            this.disabled = false;
            if (this.timer) clearInterval(this.timer);
            localStorage.setItem('lang', this.language);
            // this.$router.go(0);
        },
        // 公司名输入框-关联公司-前5条数据
        companyNameInput: function () {
            var that = this;
            getQueryEnterpriseName({
                "name": that.info.CompanyName
            }).then((res) => {
                if (res.Data.length > 5) {
                    that.companylist = res.Data.slice(0, 5);
                } else {
                    that.companylist = res.Data;
                }
            }, fail => { })
        },
        // 获取手机号验证码（中文）
        getPhoneCode: function () {
            var that = this;
            that.info.Mobile = that.info.Mobile.trim();
            // 中国(+86)使用sendSMS，需要验证手机号格式
            if (that.info.AreaCode === '+86') {
                if (!validator.isPhone(that.info.Mobile)) {
                    that.Common.toast(that.content.phone_err);
                    return false;
                }
                sendSMS({
                    "Mobile": that.info.Mobile,
                    "Type": 6
                }).then((res) => {
                    that.Common.toast('验证码已发送', 'success');
                    that.disabled = true;
                    that.countDown();
                }, fail => {
                    that.disabled = false;
                })
            } else {
                // 港澳台等其他区号，需要验证，使用sendSMSToGlobal
                if (that.info.Mobile == "") {
                    that.Common.toast(that.content.phone_err);
                    return false;
                }
                sendSMSToGlobal({
                    "Mobile": that.info.AreaCode.replace("+", "") + that.info.Mobile,
                    "Type": 6
                }).then((res) => {
                    that.Common.toast('验证码已发送', 'success');
                    that.disabled = true;
                    that.countDown();
                }, fail => {
                    that.disabled = false;
                })
            }
        },
        // 手机号失去焦点-获取预登记信息（中文）
        onPhoneCodeBlur: function (e) {
            var that = this;
            if(that.language === 'zh' && that.info.AreaCode === '+86'){
                if (!validator.isPhone(that.info.Mobile)) {
                    that.Common.toast(that.content.phone_err);
                    return false;
                }
            }
            if (that.info.Code == "") return false;
            beforeInfo({
                "Mobile": that.info.Mobile,
                "Code": that.info.Code,
            }).then((res) => {
                that.info.CompanyName = data.Data.CompanyName;
                that.info.Duty = data.Data.Duty;
                // 国家是中国
                if (that.info.CountryId == 43167) {
                    that.info.ProvinceName = data.Data.ProvinceName;
                    that.info.CityName = data.Data.CityName;
                    that.info.RegionName = data.Data.RegionName;
                    that.info.Address = data.Data.Address;
                    that.getArea(that.info.CountryId, 'province', true);
                }
            }, fail => {
                if (fail.Msg == "已报名") {
                    that.Common.toast(fail.Msg);
                    localStorage.setItem('mobile', that.info.Mobile);
                    setTimeout(() => {
                        this.$router.push({ path: "/ticket" });
                    }, 1000)
                } else if (fail.Msg.indexOf('登记信息') > -1) {

                } else {
                    that.Common.toast(fail.Msg);
                }
            });
        },
        // 获取邮箱验证码（英文）
        getEmailCode: function () {
            var that = this;
            if (!validator.isEmail(that.info.Email)) {
                that.Common.toast(that.content.email_err);
                return false;
            }
            sendEmailCode({
                "Email": that.info.Email
            }).then((res) => {
                that.Common.toast('Verification code sent.', 'success');
                that.disabled = true;
                that.countDown();
            }, fail => {
                that.disabled = false;
            })
        },
        // 60秒后重新获取验证码
        countDown: function () {
            var that = this;
            var num = 60;
            if (that.timer) clearInterval(that.timer);
            that.timer = setInterval(function () {
                if (num > 0) {
                    that.content.code_get = `${num}s`;
                    num--;
                } else {
                    clearInterval(that.timer);
                    that.content.code_get = that.language === 'zh' ? "重新发送" : "Resend";
                    that.disabled = false;
                }
            }, 1000)
        },
        // 国家-弹窗
        getCountryValue: function () {
            if (this.gjKeyword == "") {
                if (this.language === 'zh') {
                    this.gjArray = [...this.allCountry];
                } else {
                    this.gjArray = this.allCountry.filter(item => item.id !== 43167);
                }
            }
        },
        onCountryConfirm: function () {
            let query = this.gjKeyword.trim();
            if (!query) return;
            let nameKey = this.language === 'zh' ? "name" : "name_en";
            let result = this.allCountry.filter(item => {
                return item[`${nameKey}`].includes(query);
            });
            if (result.length == 0) {
                this.Common.showMsg(this.content.country_search_no_err, null, null, true);
            }
            this.gjArray = result;
        },
        onCountryClear: function () {
            this.gjKeyword = '';
            if (this.language === 'zh') {
                this.gjArray = [...this.allCountry];
            } else {
                this.gjArray = this.allCountry.filter(item => item.id !== 43167);
            }
        },
        gjConfirm: function () {
            if (!this.country.id) return;
            this.info.Country = this.country.name;
            this.info.CountryId = this.country.id;
            this.info.ProvinceName = "";
            this.info.CityName = "";
            this.info.RegionName = "";
            this.areaArray = [
                {values: [],defaultIndex: 0},
                {values: [],defaultIndex: 0},
                {values: [],defaultIndex: 0}
            ];
            this.getArea(this.info.CountryId, 'province');
            this.gjShow = false;
        },
        onCountryItemSelect: function (item) {
            this.country.name = this.language === 'zh' ? item.name : item.name_en;
            this.country.id = item.id;
        },
        // 获取地址-省市区县
        openArea: function () {
            this.areaShow = true;
            if (this.areaArray[0].values.length === 0) {
                this.getArea(this.info.CountryId, 'province');
            }
        },
        // 省市区县滚动触发-Picker实例，所有列选中值，当前列对应的索引
        onAreaChange: function (picker, values, index) {
            // console.log('当前选中的值:', values, '当前滑动列:', index);
            const id = values[index].id;
            if (index == 0) {
                // 省
                this.areaArray[1].defaultIndex = 0;
                this.areaArray[2].defaultIndex = 0;
                this.getArea(id, 'city');
            } else if (index == 1) {
                // 市
                this.areaArray[2].defaultIndex = 0;
                this.getArea(id, 'county');
            } else if (index == 2) {
                // 区
            } else { }
        },
        // 省市区县确定
        onAreaConfirm: function (value, index) {
            // console.log(`当前值：${value[0].name}, 当前索引：${index}`);
            let name = this.language === 'zh' ? 'name' : 'name_en';
            this.info.ProvinceName = value[0] ? value[0][`${name}`] : "";
            this.info.CityName = value[1] ? value[1][`${name}`] : "";
            this.info.RegionName = value[2] ? value[2][`${name}`] : "";
            this.areaShow = false;
        },
        /**
         * 获取地区数据
         * @param {string|number} pid - 父级ID
         * @param {string} level - 当前加载的级别 ('country'|'province'|'city'|'county')
         * @param {boolean} init - 初始化数据，根据已有的值，处理value
         */
        getArea: function (pid, level, init = false) {
            var that = this;
            return new Promise((resolve, reject) => {
                if (level != 'country' && !pid) {
                    reject('地区数据加载失败');
                    return false;
                };
                getApiArea({
                    "pid": pid
                }).then((res) => {
                    let { list } = res.Data;
                    let nameKey = that.language === 'zh' ? 'name' : 'name_en';
                    // 根据级别更新对应的数据
                    switch (level) {
                        case 'country':
                            that.allCountry = list;
                            if (that.language === 'zh') {
                                that.gjArray = list;
                            } else {
                                that.gjArray = list.filter(item => item.id !== 43167);
                            }
                            that.info.Country = that.gjArray[0][`${nameKey}`];
                            that.info.CountryId = that.gjArray[0].id;
                            that.country = {
                                name: that.gjArray[0][`${nameKey}`],
                                id: that.gjArray[0].id
                            }
                            if(that.gjArray.length > 0){
                                that.getArea(that.info.CountryId, 'province', init);
                            }
                            break;
                        case 'province':
                            that.areaArray = [
                                { values: list, defaultIndex: 0 },
                                { values: [], defaultIndex: 0 },
                                { values: [], defaultIndex: 0 }
                            ]
                            if (list.length > 0) {
                                if (init && that.info.ProvinceName) {
                                    const index = list.findIndex(item => item[`${nameKey}`] === that.info.ProvinceName)
                                    that.areaArray[0].defaultIndex = index;
                                }
                                that.getArea(list[0].id, 'city', init);
                            }
                            break;
                        case 'city':
                            that.areaArray[1].values = list;
                            that.areaArray[2].values = [];
                            if (list.length > 0) {
                                if (init && that.info.CityName) {
                                    const index = list.findIndex(item => item[`${nameKey}`] === that.info.CityName)
                                    that.areaArray[1].defaultIndex = index;
                                    that.areaArray[2].defaultIndex = 0;
                                }
                                that.getArea(list[0].id, 'county', init);
                            }
                            break;
                        case 'county':
                            that.areaArray[2].values = list;
                            if (init && that.info.RegionName) {
                                const index = list.findIndex(item => item[`${nameKey}`] === that.info.RegionName)
                                that.areaArray[2].defaultIndex = index;
                            }
                            break;
                    }
                    resolve();
                }, fail => { })
            })
        },
        // 提交
        nextClick: function () {
            var that = this;
            var info = that.info;
            if (info.Name == '') {
                that.Common.toast(that.content.name_placeholder);
                return false;
            }
            info.Mobile = info.Mobile.trim();
            if(that.language === 'zh' && info.AreaCode === '+86'){
                if (!validator.isPhone(info.Mobile)) {
                    that.Common.toast(that.content.phone_err);
                    return false;
                }
            } else {
                if (info.Mobile == "") {
                    that.Common.toast(that.content.phone_placeholder);
                    return false;
                }
            }
            if (info.Code == '') {
                that.Common.toast(that.content.code_placeholder);
                return false;
            }
            if (!validator.isEmail(info.Email)) {
                that.Common.toast(that.content.email_err);
                return false;
            }
            if (info.IdCode == '') {
                that.Common.toast(that.content.idcode_placeholder);
                return false;
            }
            if (info.CompanyName == '') {
                that.Common.toast(that.content.company_placeholder);
                return false;
            }
            if (info.Duty == '') {
                that.Common.toast(that.content.duty_placeholder);
                return false;
            }
            if (info.JobFunction == '') {
                that.Common.toast(that.content.job_placeholder);
                return false;
            }
            if (info.Country == '') {
                that.Common.toast(that.content.country_placeholder);
                return false;
            }
            // 省市区根据接口规定，有几级就选到几级
            if (that.areaArray[0].values.length > 0 && info.ProvinceName == '') {
                that.Common.toast(that.content.address_placeholder1);
                return false;
            }
            if (info.Address == '') {
                that.Common.toast(that.content.address_placeholder2);
                return false;
            }
            that.submitting = true;
            const intlPrefix = that.language === 'zh' ? info.AreaCode !== '+86' ? info.AreaCode.replace("+", "") : "" : "";
            addRecords({
                "Name": info.Name,
                "Duty": info.Duty,
                "IntlPrefix": intlPrefix,
                "Mobile": info.Mobile,
                "IdCode": info.IdCode,
                "IdType": info.IdType,
                "Address": info.Address,
                "CityName": info.CityName,
                "CompanyName": info.CompanyName,
                "ProvinceName": info.ProvinceName,
                "RegionName": info.RegionName,
                "Email": info.Email,
                "ShareMemberId": info.ShareMemberId,
                "ShareStoreId": info.ShareStoreId,
                "Code": info.Code,
                "ExhibitionQuestions": info.ExhibitionQuestions,
                "CnId": info.CnId,
                "Sex": info.Sex,
                "JobFunction": info.JobFunction,
                "Country": info.Country,
                "IsInter": that.language === 'zh' ? 0 : 1
            }).then((res) => {
                setTimeout(() => {
                    that.Common.toast(that.content.success, 'success');
                    localStorage.setItem('mobile', info.Mobile);
                    setTimeout(() => {
                        this.$router.push({ path: "/ticket" });
                    }, 1500)
                }, 0);
            }, fail => {
                that.submitting = false;
            })
        }
    },
    mounted() {
        var that = this;
        const lang = localStorage.getItem('lang') || that.$route.query.lang || 'zh';
        that.language = lang;
        that.content = that.messages[lang];
        // console.log('当前语言', lang);
        // 提示
        // that.Common.showMsg("2026广州国际照明展览会（光亚展）\n观众预登记通道暂未开启，请耐心等候", function () {
        //     that.$router.push({ path:"/exhibition" });
        // });
        // return false;
        that.info.ShareMemberId = that.$route.query.mid || 0;
        that.info.ShareStoreId = that.$route.query.sid || 0;
        const cnid = that.$route.query.cnid || 0;
        that.info.CnId = cnid;
        addViews({ "CnId": cnid }).then((res) => { })
        getApiInfo().then((res) => {
            that.certificates = res.Data.config || [];
            that.idtypeArray = lang == 'zh' ? res.Data.config.certificates_type : res.Data.config.certificates_type_en;
            that.jobArray = res.Data.dictionary.job_function || [];
        })
        that.getArea(0, 'country');
    },
};
</script>
<style scoped src="../../../static/css/attendinfo.css"></style>
<style scoped>
.phone-input-wrapper {
    display: flex;
    align-items: center;
    width: 100%;
}
.area-code-select {
    width: 70px;
    min-width: 70px;
    height: 30px;
    padding: 0 5px;
    margin-right: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    font-size: 14px;
    color: #333;
    outline: none;
    -webkit-appearance: none;
    appearance: none;
    background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"><path fill="%23999" d="M6 8L1 3h10z"/></svg>');
    background-repeat: no-repeat;
    background-position: right 8px center;
    background-size: 12px;
    padding-right: 25px;
}
.area-code-select option {
    height: 30px;
    line-height: 30px;
    padding: 5px 10px;
}
.area-code-select:focus {
    border-color: #1890ff;
}
.phone-input-wrapper input {
    flex: 1;
}
</style>